/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import Label from "../../../components/label";
import EditProfileForm from "../../../containers/EditProfileForm";
import { NavLink } from "react-router-dom";
import appRoutes from "../../../routes/appRoutes";
import MakeAPICall from "../../../apiCalls/common";
import { getUserProfile, updateUserProfile } from "../../../apiRoutes";
import Loader from "../../../components/loader";
import { updateUserData } from "../../../reduxStore/actions/auth";
import {STATE_LIST} from "../../../constants/helperConstants";

class ProfileEditPage extends Component {

  constructor(props){
    super(props);
    this.state = {
      userData : null,
      apiCall: null,
      apiLoading: false
    }
  }

  componentDidMount(){
    window.scrollTo(0, 0);
    this.setState({
      apiLoading: true
    });
    let apiCallParam = {
      reqType: "GET",
      reqURL: getUserProfile,
      dataObj: {},
      params: {},
      headers: {},
      successCallback: res => {
        this.setState({
          userData: res.data.data[0],
          apiLoading: false
        });
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
        this.setState({
          apiLoading: false
        });
      },
      showPopUp: false
    };
    this.setState({apiCall: apiCallParam});

  }

  componentAPICall = data => {
    this.setState({ apiCall2: data });
  };

  handleUserData = (data) => {
    this.setState({
      userData: data
    });
  }

  onProfileFormSubmit = formValues => {
    this.setState({
      apiLoading: true
    });
    window.scrollTo(0, 0);
    let apiCallParam = {
      reqType: "PUT",
      reqURL: updateUserProfile,
      dataObj: formValues,
      params: {},
      headers: {},
      successCallback: res => {
        let stateUpdateData = {
          userData : res.data.data,
          appConstant: this.props.auth.appConstant
        };
        this.props.updateUserData(stateUpdateData);
        this.setState({
          apiLoading: false
        });
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
        this.setState({
          apiLoading: false
        });
      },
      showPopUp: true,
      redirect: appRoutes.profile
    };
    this.setState({apiCall: apiCallParam});
  };

  render() {
    return (
      <div className="row rounded p-3 my-profile-edit-page">
        <div className="col-sm-12 p-3">
          <NavLink
            to={appRoutes.profile}
            className="insta-link-orange font-15 text-decoration-none"
            href="#"
          >
            <i className="fas fa-arrow-left"></i>{" "}
            <span className="ml-1 pt-1 back-btn-text"> Back to Profile</span>
          </NavLink>
        </div>

        <div className="col-sm-12 pl-3 pb-3">
          <Label title="Edit Profile" className="big" />
        </div>
        <div className="col-sm-12 border-bottom"></div>

        <div className="col-sm-12 mt-4">
          <EditProfileForm onFormSubmit={this.onProfileFormSubmit} userData={this.state.userData} stateList={STATE_LIST}  makeAPICall={this.componentAPICall} />
        </div>
        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />
        {/* Loader */}
        <Loader loading={this.state.apiLoading}/>
      </div>
    );
  }
}

// export default ProfileEditPage;
const mapStateToProps = state => ({
  auth: state.auth.user
});

const mapDispatchToProps = dispatch => ({
  updateUserData: (data) => dispatch(updateUserData(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileEditPage);


